import type { ReactNode } from 'react';

type Tone = 'neutral' | 'accent' | 'success' | 'warning';

const TONE_CLASSES: Readonly<Record<Tone, string>> = {
  neutral: 'bg-muted text-muted-foreground',
  accent: 'bg-accent/10 text-accent',
  success: 'bg-primary/10 text-primary',
  warning: 'bg-destructive/10 text-destructive',
};

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-sm font-medium ${TONE_CLASSES[tone]}`}
    >
      {children}
    </span>
  );
}
